module.exports = __webpack_public_path__ + "static/media/i3.43a64020.png";